import React, { createContext, useState, useEffect, useContext } from 'react';
import jwt_decode from 'jwt-decode';
import api from '../api';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedUser = jwt_decode(token);
      setUser(decodedUser);
    }
    setLoading(false);
  }, []);

  const login = async (email, password, navigate) => {
    const res = await api.post('/auth/login', { email, password });
    const { token } = res.data;
    localStorage.setItem('token', token);
    const decodedUser = jwt_decode(token);
    setUser(decodedUser);
    navigate('/dashboard'); // Programmatically navigate after login
  };

  const register = async (email, password, role, navigate) => {
    const res = await api.post('/auth/register', { email, password, role });
    const { token } = res.data;
    localStorage.setItem('token', token);
    const decodedUser = jwt_decode(token);
    setUser(decodedUser);
    navigate('/dashboard'); // Programmatically navigate after registration
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    register,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin',
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
